import { useEffect } from "react";
import useNav from "../../hooks/useNav";

export default function LoginRedirect() {
  const nav = useNav();

  useEffect(() => {
    nav("/login", { replace: true });
  }, [nav]);

  return null;
}
